import React, { useEffect, useState } from "react";
import "../appointment/style.css";
import { useNavigate } from "react-router-dom";
import "./style.css";
import BlogBox from "./BlogBox";
import BlogTodayPost from "./BlogTodayPost";
import { Calendar } from "react-date-range";
import { format, isToday, parseISO } from "date-fns";
import { getBlogListService } from "../../services/BlogService";
const AllBlogsNew = () => {
  const [scheduleDate, setScheduleDate] = useState();
  const [list, setList] = useState([]);
  const [newDate, setNewDate] = useState(new Date());

  useEffect(() => {
    getBlogList();
  }, [newDate]);

  const getBlogList = async () => {
    try {
      const response = await getBlogListService();
      if (response) {
        setList(
          response.filter((item) => {
            if (!item.publishTime) return false;
            return (
              format(parseISO(item.publishTime), "yyyy-MM-dd") ===
              format(newDate, "yyyy-MM-dd")
            );
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div class="row mt-3">
        <div className="col-md-12 col-lg-4">
          <p className="scheduledpost_back rounded px-3">Scheduled Posts</p>
          <Calendar
            color={"#1f7e78"}
            date={newDate}
            onChange={(item) => {
              // setScheduleDate(format(item, "yyyy-MM-dd"));
              setNewDate(item);
            }}
          />

          <BlogTodayPost isToday={isToday(newDate)} list={list} />
        </div>
        <div className="col-md-12 col-lg-8">
          <p className="post_heading mt-2">
            {scheduleDate ? "Schedule blogs" : "Drafts"}
          </p>
          <BlogBox scheduleDate={scheduleDate} />
        </div>
      </div>
    </>
  );
};

export default AllBlogsNew;
